import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NewPatientForm = () => {
  const [iframeHeight, setIframeHeight] = useState('1600px');

  useEffect(() => {
    // Set initial height based on screen size
    setIframeHeight(window.innerWidth <= 768 ? '2400px' : '1600px');

    // Update height on window resize
    const handleResize = () => {
      setIframeHeight(window.innerWidth <= 768 ? '2400px' : '1600px');
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Header />
      <div id="content" role="main" className="home">
        {/* Title */}
        <div id="interior-header-container" className="container-fluid">
          <div className="container">
            <h1>New Patient Form</h1>
          </div>
        </div>

        {/* Alert for current patients */}
        <div className="container-fluid text-center p-0">
            <div 
              className="alert alert-info m-0" 
              style={{ backgroundColor: '#e9f8fb', borderColor: '#b8e7f0', color: '#0c5460' }}
              role="alert"
            >
              <strong>Important:</strong> Please do not fill out this form if you are already a current patient, this is for new patient requests only.
              <br />
              Current patients please use our <a href="/contact" className="alert-link" style={{ color: '#0c5460', textDecoration: 'underline' }}>contact form</a> for any inquiries.
            </div>
        </div>

        {/* Large iframe with responsive height */}
        <div className="container-fluid p-0">
          <iframe
            src="https://valant.io/prospectivepatient/RP/embedded"
            style={{
              width: '100%',
              height: iframeHeight,
              border: 'none',
              overflow: 'hidden',
            }}
            scrolling="no"
            title="New Patient Form"
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewPatientForm;
